import { atom } from 'jotai'
import { selectAtom } from 'jotai/utils'
import * as R from 'remeda'

import { type Survey } from '~/gql/graphql'
import { type SurveyGroupFilterGroups } from '~/utils'

type OnChange = (
  data:
    | {
        countMap: Record<Survey['id'], number>
        filterGroups: SurveyGroupFilterGroups
      }
    | undefined,
) => void
export const propAtom = atom<{
  surveyGroupId: string
  onChange: OnChange
}>({
  surveyGroupId: null as unknown as string,
  onChange: R.doNothing,
})
export const surveyGroupIdAtom = selectAtom(propAtom, R.prop('surveyGroupId'))
export const onChangeAtom = selectAtom(propAtom, R.prop('onChange'))

export const isVisibleEditDialogAtom = atom(false)
